
import * as React from 'react';
import { Action } from '../../action/Action';
import { withCurrentItemSet } from '../../decorators/selectors';
import { WithItemsView, IWithItemsViewStateProps } from '../../itemsView/ItemsViewBeta';

export interface ISetPreferredLayoutActionProps {
  itemKey: string;
  layoutHandlerKey: string;
}

/**
 * Action component to switch the preferred layout to use the handler with the specified key.
 * This action is available if the given layout handler is one of the allowed layout handlers
 * for the given item.
 * Executing this action sets the layout handler's key as the preferred layout within the items scope.
 */
export class ItemSetPreferredLayoutAction extends React.PureComponent<ISetPreferredLayoutActionProps> {
  public render(): JSX.Element {
    const {
      itemKey,
      layoutHandlerKey
    } = this.props;

    return (
      <WithItemsView
        itemKey={ itemKey }
      >
        { ({ layoutHandlers }: IWithItemsViewStateProps) => {
          let currentLayoutHandlerKey: string | undefined;

          let switchLayout: (() => void) | undefined;

          for (const {
            layout,
            setAsPreferredLayout,
            key
          } of layoutHandlers) {
            if (layout && !currentLayoutHandlerKey) {
              // Keep track of the first valid layout. This is the 'current' layout.
              currentLayoutHandlerKey = key;
            }

            if (key === layoutHandlerKey && layout) {
              // Find the target layout in the set of available layouts, to determine availability.
              switchLayout = setAsPreferredLayout;
            }

            if (currentLayoutHandlerKey && switchLayout) {
              // Once both answers have been found, stop iterating.
              break;
            }
          }

          const finalSwitchLayout = switchLayout;

          // This action is available as long as it's 'switchLayout' function has been found.
          const onExecute = finalSwitchLayout ? async () => {
            finalSwitchLayout();
          } : undefined;

          return (
            <Action
              onExecute={ onExecute }
              isToggled={ layoutHandlerKey === currentLayoutHandlerKey }
            />
          );
        } }
      </WithItemsView>
    );

  }
}

export const SetPreferredLayoutAction = withCurrentItemSet()(ItemSetPreferredLayoutAction);
